import * as XLSX from "xlsx";
import { getFinancialReportMeta } from "../../../../hooks/useFinancialReport";
import { formatDate, formatMonthLabel } from "../pdf/shared";

function periodRows(data) {
  return [
    {
      Campo: "Período início",
      Valor: data?.from ? formatDate(data.from) : "—",
    },
    {
      Campo: "Período fim",
      Valor: data?.to ? formatDate(data.to) : "—",
    },
  ];
}

function buildHonorariosRecebidos(data) {
  const items = data?.items ?? [];
  const totals = data?.totals ?? {};
  const rows = items.map((r) => ({
    Cliente: r.client || "—",
    Processo: r.lawsuit_number || "—",
    Tipo: r.type || "—",
    Contratado: Number(r.contracted_value) || 0,
    Recebido: Number(r.received_value) || 0,
    Saldo: Number(r.saldo) || 0,
    Atualizado: formatDate(r.updated_at),
  }));
  rows.push({
    Cliente: "TOTAL",
    Processo: "",
    Tipo: `Itens: ${totals.items_count ?? items.length}`,
    Contratado: Number(totals.contracted_value) || 0,
    Recebido: Number(totals.received_value) || 0,
    Saldo: Number(totals.saldo) || 0,
    Atualizado: "",
  });
  return rows;
}

function buildHonorariosPorCliente(data) {
  const items = data?.items ?? [];
  const totals = data?.totals ?? {};
  const rows = items.map((r) => ({
    Cliente: r.client || "—",
    Qtd: Number(r.items_count) || 0,
    Contratado: Number(r.contracted_value) || 0,
    Recebido: Number(r.received_value) || 0,
    Saldo: Number(r.saldo) || 0,
  }));
  rows.push({
    Cliente: "TOTAL",
    Qtd: Number(totals.items_count) || 0,
    Contratado: Number(totals.contracted_value) || 0,
    Recebido: Number(totals.received_value) || 0,
    Saldo: Number(totals.saldo) || 0,
  });
  return rows;
}

function buildMonthlyTotal(data) {
  const months = data?.months ?? [];
  const totals = data?.totals ?? {};
  const rows = months.map((r) => ({
    Mês: formatMonthLabel(r),
    Qtd: Number(r.items_count) || 0,
    Total: Number(r.total) || 0,
  }));
  rows.push({
    Mês: "TOTAL",
    Qtd: Number(totals.items_count) || 0,
    Total: Number(totals.total) || 0,
  });
  return rows;
}

function buildFluxoDeCaixa(data) {
  const months = data?.months ?? [];
  const totals = data?.totals ?? {};
  const rows = months.map((r) => ({
    Mês: formatMonthLabel(r),
    Entradas: Number(r.entradas) || 0,
    Saídas: Number(r.saidas) || 0,
    Saldo: Number(r.saldo) || 0,
  }));
  rows.push({
    Mês: "TOTAL",
    Entradas: Number(totals.entradas) || 0,
    Saídas: Number(totals.saidas) || 0,
    Saldo: Number(totals.saldo) || 0,
  });
  return rows;
}

function buildSheetRows(type, data) {
  switch (type) {
    case "honorarios-recebidos":
      return buildHonorariosRecebidos(data);
    case "honorarios-por-cliente":
      return buildHonorariosPorCliente(data);
    case "receitas-por-mes":
    case "despesas-por-mes":
      return buildMonthlyTotal(data);
    case "fluxo-de-caixa":
      return buildFluxoDeCaixa(data);
    default:
      return [];
  }
}

/**
 * Builds and downloads an .xlsx for the given financial report type and API data.
 * @param {string} type
 * @param {object} data
 */
export function exportFinancialReportExcel(type, data) {
  const meta = getFinancialReportMeta(type);
  const sheetRows = buildSheetRows(type, data);
  const wb = XLSX.utils.book_new();

  const periodWs = XLSX.utils.json_to_sheet([
    { Campo: "Relatório", Valor: meta.label },
    ...periodRows(data),
  ]);
  XLSX.utils.book_append_sheet(wb, periodWs, "Período");

  const dataWs = XLSX.utils.json_to_sheet(
    sheetRows.length
      ? sheetRows
      : [{ Info: "Nenhum registro no período selecionado." }]
  );
  const sheetName = meta.label.slice(0, 31);
  XLSX.utils.book_append_sheet(wb, dataWs, sheetName);

  const fileName = `relatorio-${meta.filename}-${Date.now()}.xlsx`;
  XLSX.writeFile(wb, fileName);
}
